import { render, staticRenderFns } from "./Wysiwyg.vue?vue&type=template&id=e3798136&"
import script from "./Wysiwyg.js?vue&type=script&lang=js&"
export * from "./Wysiwyg.js?vue&type=script&lang=js&"
import style0 from "./Wysiwyg.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports